module.exports = __webpack_public_path__ + "static/img/technology8.9cbc2531.png";